import { Tone } from "@shopify/polaris/build/ts/src/components/Badge";

export const tabs: any =(t:any)=> [
    {
        id: 'pending_approval',
        content: t('Pending'),
        accessibilityLabel: 'Pending',
        panelID: 'Pending',
        date: "Requested",
        date_key: "created_at",
        show_approve: true,
        show_rejected: true,
    },
    {
        id: 'approved',
        content: t('Approved'),
        accessibilityLabel: 'Approved',
        panelID: 'Approved',
        date: "Approved",
        date_key: "approved_at",
    },
    {
        id: 'rejected',
        content: t('Rejected'),
        accessibilityLabel: 'Rejected',
        panelID: 'Rejected',
        date: "Rejected",
        date_key: "rejected_at",
        show_approve: true,
    },
];

export const getStatusBadge = (status: string,t:any): { tone: Tone, updatedStatus: string } => {
    let tone: Tone = "success";
    switch (status) {
        case "pending_approval":
            tone = "attention";
            break;
        case "rejected":
            tone = "critical";
            break;
        default:
            tone = "success";
    }
    if (status === "pending_approval") {
        status = "pending"
    }
    return {
        tone,
        updatedStatus: t(capitalizeFirstChar(status)),
    }
}

function capitalizeFirstChar(str: string) {
    if (str.length === 0) {
        return str;
    }
    return str.charAt(0).toUpperCase() + str.slice(1);
}